import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import PageApp from 'pageApp';
import { HORIZONTAL, VERTICAL } from '@component/product-pool-media';
import ContentCarouselView from '../views/ContentCarouselView';
import ProductThumbnailView from '../views/ContentProductThumbnailView';
import Carousel from './Carousel';

export default class ContentCarousel extends Carousel {
  getContentTargetUrl() {
    const contentId = encodeURIComponent(this.content.contentId);
    const zone = encodeURIComponent(this.config.zone);
    const choiceId = encodeURIComponent(((this.config.encodedChoiceId.split('-'))[0] || '').replace(/^cid/, ''));
    let targetPath = '/shop/featured/';
    _.each(this.thumbnailCollection.models, (product, index) => {
      targetPath += ((index === 0) ? '' : ',') + product.get('id');
    });
    targetPath += `?prosSource=con&prosContent=${contentId}&prosZone=${zone}&prosChoiceId=${choiceId}`;
    this.content.contentTargetUrl = targetPath;
  }

  dispatchPixelEvent({ pageIdsPos, currentPage, config }) {
    const that = this;
    const scrollListener = (view) => {
      const windowTop = $(window).scrollTop() + $(window).height();
      const prosPanelTop = view.$el.offset().top;
      if (windowTop > prosPanelTop) {
        // console.log('passed', windowTop, prosPanelTop);
        view.prosEventHandler.sendPixelEvent({
          pageIdsPos, currentPage, config, content: view.content,
        });
        // eslint-disable-next-line no-param-reassign
        view.pixelEventDispatched = true;
      }
    };

    if (this.properties.pixelPresentedEnabled) {
      scrollListener(this);

      if (!this.pixelEventDispatched) {
        $(window).scroll(() => {
          scrollListener(that);
        });
      }
    }
  }

  loadCollection(json) {
    this.content = json.content;
    this.thumbnailCollection = this.thumbnailCollectionClass.fromArray(json.recommendedIdsList, {
      model: this.thumbnailModel,
      content: json.content,
      imageWidth: 400,
      arrowIconSize: this.config.arrowIconSize,
    });
    this.thumbnailCollection.content = this.content;
  }
  createPanel({ items }) {
    const model = this.getPanelData(items);

    this.getContentTargetUrl();
    model.set('content', this.content);

    const config = {
      carouselType: this.config.orientation === 'vertical' ? VERTICAL : HORIZONTAL,
      zone: this.config.zone,
    };

    $(this.config.element).addClass('pros-factory-carousel pros-content-carousel');

    this.thumbnailView = ProductThumbnailView.extend({
      tagName: 'li',
    });

    this.panel = new ContentCarouselView({
      el: this.config.element,
      model,
      childView: this.thumbnailView,
      config,
    });
  }

  getPanelData(items) {
    const { currentPage } = this.pagination;
    this.collectionBuffer.reset(items, { silent: true });

    // call @product-pool-media to render component
    const productPoolCollection = new Backbone.Model({
      productPoolMedia: {
        brand: PageApp.brand,
        poolLink: {
          text: this.config.headerText,
        },
      },
      content: (currentPage === 1) ? this.content : null,
    });

    productPoolCollection.get('productPoolMedia').collection = this.collectionBuffer;
    return productPoolCollection;
  }

  onRender() {
    const that = this;
    super.onRender();
    const originalDoSizing = this.panel.carouselView.doSizing;

    this.panel.carouselView.doSizing = function doSizing() {
      const preAppendChildren = this.scroller.getElementsByTagName('li');
      that.panel.carouselView.childSize.childWidth = preAppendChildren[1].offsetWidth;
      originalDoSizing.call(that.panel.carouselView);
    };
  }

  // eslint-disable-next-line class-methods-use-this
  initNavigation() {}
}
